import React, { useState, useEffect } from 'react';
import { WebinarItem } from './components/WebinarItem';
import { ScrollButton } from '../ScrollToTop/ScrollToTop';
import { WebinarLandingItem, WebinarPage } from '@pages/Webinars/Webinars.types';
import { selectWebinarsFilter } from '../../Webinar.slice';
import { useSelector } from '@store/store';
import { doDataLayerPush } from './WebinarData.helpers';

interface WebinarDataProps {
  webinarBanner: WebinarLandingItem;
  webinarPageData: WebinarPage;
}

const WebinarData = ({ webinarBanner, webinarPageData }: WebinarDataProps) => {
  const [page, setPage] = useState(1);
  const filters = useSelector(selectWebinarsFilter);

  const loadMoreSize = 9;
  const webinarListItems = webinarPageData?.WebinarItems || [];
  const visibleItems = loadMoreSize * page;
  const totalItems = webinarListItems.length;

  const filteredItems = webinarListItems
    .filter((item) => {
      // filter by type
      if (filters.type === 'All') {
        return true;
      }
      return item.WebinarStatus === filters.type;
    })
    .filter((item) => {
      // filter by category
      if (filters.category === 'All') {
        return true;
      }
      return item.CategoryIndustryItems.some(
        (category) => category.CategoryID.toString() === filters.category
      );
    });

  const showMoreWebinars = () => {
    setPage((page) => page + 1);
  };

  useEffect(() => {
    setPage(1);
  }, [filters]);

  return (
    <>
      <div className='webinarData'>
        {filteredItems.length > 0 && (
          <div className='webinarList'>
            {`${filteredItems.length} ${
              filteredItems.length > 1
                ? webinarPageData.WebinarsLabel
                : webinarPageData.WebinarLabel
            }`}
          </div>
        )}

        <div className='webinar-container'>
          {filteredItems.slice(0, visibleItems).map((item, index: number) => (
            <WebinarItem
              key={index + 'webinar-block'}
              index={index}
              webinarData={item}
              i18n={{
                Months: webinarBanner.Months,
                LiveLabel: webinarPageData.LiveLabel,
                DurationLabel: webinarPageData.DurationLabel || '',
                RegisterNowButtontext: webinarBanner.RegisterNowButtontext,
                ViewOnDemandButtonText: webinarBanner.ViewOnDemandButtonText,
              }}
              onWebinarLinkClick={(webinar) => {
                doDataLayerPush(webinar, filters);
              }}
              dateFormat={webinarBanner.DateFormat}
            />
          ))}
        </div>
      </div>
      {webinarBanner && filteredItems.length > visibleItems && (
        <div className='show-more-btn'>
          <button className='showmore-webinar is-medium' onClick={showMoreWebinars}>
            {webinarBanner.LoadMoreButtonText}
          </button>
        </div>
      )}

      {!filteredItems.length && (
        <div className=''>
          <p style={{ textAlign: 'center' }}>{webinarPageData?.ResultNotFound || null}</p>
        </div>
      )}

      {webinarBanner && <ScrollButton btnText={webinarBanner.AllTheWayUpButtonText} />}
    </>
  );
};

export default WebinarData;
